<p-autoComplete
  #autocomplete
  [ngModel]="value()"
  (ngModelChange)="valueChange.emit($event)"
  [suggestions]="suggestions()"
  (completeMethod)="onComplete($event)"
  (onClear)="cleared.emit()"
  [delay]="delay()"
  (onDropdownClick)="dropdownOpen.emit()"
  (onFocus)="dropdownOpen.emit()"
  (keydown.enter)="onEnter($event)"
  placeholder="{{ placeholder() | transloco }}"
  [forceSelection]="true"
  [completeOnFocus]="true"
  [dropdown]="true"
  [group]="true"
  optionGroupLabel="label"
  optionGroupChildren="items"
  [optionLabel]="optionLabel()"
  class="w-full"
  inputStyleClass="w-full"
  [disabled]="disabled()"
  appendTo="body"
  [attr.data-testid]="testId()"
>
  <ng-template #header>
    @if (!addButtonDisabled()) {
      <div class="px-3 py-3">
        <p-button
          label="{{ addButtonLabel() | transloco }}"
          fluid
          size="small"
          icon="pi pi-plus"
          (onClick)="add.emit()"
        />
      </div>
    }
  </ng-template>
  <ng-template let-group #group>
    <span class="font-bold uppercase text-sm tracking-wide">{{ group.label }}</span>
  </ng-template>
  <ng-template let-item #item>
    <div
      class="flex items-center justify-between w-full"
      [attr.data-item-id]="itemIdField() ? item[itemIdField()] : null"
    >
      <span>{{ item[optionLabel()] }}</span>
      @if (isCustom()(item)) {
        <p-button
          icon="pi pi-trash"
          severity="danger"
          text
          size="small"
          (onClick)="onDelete(item, $event)"
        />
      }
    </div>
  </ng-template>
</p-autoComplete>
